import { type CarrierDef } from '../common.js'

// `api-key` is deliberately absent — J.B. Hunt issues a single API key to
// FreightView rather than per customer, so the engine holds it as a secret.
const credentialTypes = [] as const

export type hjbtCredType = (typeof credentialTypes)[number]
export const hjbt: CarrierDef<hjbtCredType> = {
  name: 'J.B. Hunt',
  scac: 'hjbt',
  credentialTypes,
  engineLayers: ['tracking'],
}
